import React, { useContext } from "react";

import { PrivateContext } from "lib/context";
import { storageHelper } from "lib/helpers";
import { SkeletonAnnotated } from "lib/components";
import constant from "lib/constant/constant";

import { OperatorProductLakeAdd } from "./operator/features";
import { ProviderProductLakeAdd } from "./provider/features";

const { userKey } = constant;
const { operator, provider } = userKey;

const ProductLakeAdd = () => {
  const { isLoading } = useContext(PrivateContext);
  const getComponent = (role) => {
    if (role === operator) {
      return <OperatorProductLakeAdd />;
    }
    if (role === provider) {
      return <ProviderProductLakeAdd />;
    }
    return null;
  };

  if (isLoading) {
    return <SkeletonAnnotated />;
  }

  const currentUserRole = storageHelper.get("userRole");
  const ProductsAddComponent = getComponent(currentUserRole);
  return ProductsAddComponent;
};

export default ProductLakeAdd;
